// extracted by mini-css-extract-plugin
module.exports = {"unauth":"styles_unauth__1m5E4","text":"styles_text__3KGVt","container":"styles_container__2qdou","title":"styles_title__30yql"};